<template>
  <div class="shop-summary-category-status" :class="['shop-summary-category-status--' + state.status]">
    <FontAwesomeIcon
      v-if="icons[state.status]"
      :icon="icons[state.status]"
      size="sm"
      class="shop-summary-category-status__icon"
    />
    <span class="shop-summary-category-status__label">{{ labels[state.status] }}</span>
    <template v-if="['signable', 'expired'].includes(state.status) && state.expiresAt">
      <span style="margin: auto;">
        <FontAwesomeIcon :icon="['fal', 'angle-right']" class="mx-1"/>
      </span>
      <span class="shop-summary-category-status__expires-at"
        >{{ $t('deadline') }}: {{ state.expiresAt | Moment('D. MMM YYYY') }}</span
      >
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Moment } from '@/filters'
import { getCategoryState } from './utils'

export default {
  props: {
    value: Object,
    shop: Object,
  },
  data() {
    return {
      icons: {
        signed: ['fas', 'check-circle'],
        signable: ['fas', 'check-circle'],
        expired: ['fas', 'exclamation-triangle'],
      },
    }
  },
  computed: {
    labels() {
      return {
        signed: this.$t('shopContractStatusSigned'),
        expired: this.$t('shopContractStatusExpired'),
        signable: this.$t('shopBuyerStatusUnsigned'),
        draft: this.$t('shopBuyerStatusDraft'),
        upcoming: `${this.$t('signableFrom')} ${Moment(this.state.signableFrom, 'D. MMM YYYY')}`
      }
    },
    state() {
      return getCategoryState(this.value.id, this.shop)
    },
  },
  filters: {
    Moment,
  },
}
</script>

<style lang="scss">
.shop-summary-category-status {
  text-align: right;
  font-size: 0.9rem;
  padding: 0.5rem 1rem;
  border: 1px solid var(--border-color);
  border-radius: var(--border-radius);
  display: flex;
  align-items: center;

  &--signed {
    color: var(--success);
    border-color: css-alpha('success', 0.2);
    background-color: css-alpha('success', 0.1);
  }

  &--signable {
    color: css-darken('warning', 20%);
    border-color: css-alpha('warning', 0.3);
    background-color: css-alpha('warning', 0.2);
  }

  &--expired {
    color: css-darken('error', 5%);
    border-color: css-alpha('error', 0.2);
    background-color: css-alpha('error', 0.1);
  }

  &--upcoming,
  &--draft {
    color: css-darken('border-color', 45%);
  }

  &__icon {
    margin-right: 5px;
  }
}
</style>
